import React from 'react';
import { TThemeColorsKey } from 'shared/design-system/theme/colors/TThemeColors';
import { StatusPillStyled, StatusText } from './StatusPill.styles';

type StatusPillProps = {
  bgColor?: TThemeColorsKey;
  margin?: string;
  text: string;
};

/**
 * @deprecated Use Tag component from `@sighten/beacon` package
 * @deprecated https://beacon.goeverbright.com/?path=/docs/components-tag--docs
 *
 * @param {string} [bgColor] - background color of indicator (defaults to green20)
 * @param {string} [text] - text displayed
 */

export function StatusPill({ bgColor, text, margin }: StatusPillProps) {
  return (
    <StatusPillStyled $bgColor={bgColor} $margin={margin}>
      <StatusText as="p">{text}</StatusText>
    </StatusPillStyled>
  );
}

export default StatusPill;
